import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

/** 経由地の到着時刻の検証で見つかった問題（行 index と表示するメッセージ） */
export type WaypointEntryTimeIssue = {
  index: number
  message: string
}

const toInstant = (value: Date | string | null | undefined): number | null => {
  if (value == null || value === '') return null
  const date = value instanceof Date ? value : new Date(value)
  const time = date.getTime()
  return Number.isNaN(time) ? null : time
}

/**
 * 経由地の到着予定時刻（#5548）を保存前に検証する。
 *
 * - 矢羽根の発時刻〜着時刻の範囲内（両端含む）
 * - 経由地の並び順に単調（前の経由地と同時刻か、それより後）
 *
 * 未入力の経由地と地点未選択の行（送信時に落とす行）は対象外。矢羽根の時刻が
 * 揃っていなければ範囲は見ず、並び順だけを見る。BE も同じ規則で弾くが、
 * どの行が悪いかを入力欄に出すために FE でも先に確かめる。
 */
export const validateWaypointEntryTimes = (
  waypoints:
    | readonly {
        siteId?: number | null
        entryTime?: Date | string | null
      }[]
    | null
    | undefined,
  range: {
    startAt: Date | string | null | undefined
    endAt: Date | string | null | undefined
  }
): WaypointEntryTimeIssue[] => {
  const issues: WaypointEntryTimeIssue[] = []
  const start = toInstant(range.startAt)
  const end = toInstant(range.endAt)
  let previous: number | null = null

  ;(waypoints ?? []).forEach((waypoint, index) => {
    if (waypoint.siteId == null) return
    const time = toInstant(waypoint.entryTime)
    if (time === null) return

    if (start !== null && end !== null && (time < start || time > end)) {
      issues.push({
        index,
        message: VALIDATION_MESSAGES.WAYPOINT_ENTRY_TIME_OUT_OF_RANGE
      })
      return
    }
    if (previous !== null && time < previous) {
      issues.push({
        index,
        message: VALIDATION_MESSAGES.WAYPOINT_ENTRY_TIME_NOT_ORDERED
      })
      return
    }
    previous = time
  })

  return issues
}
